import React from 'react';

import './PageContainer.scss';

const PageContainer = ({ children }) => {
  return <div className="container">{children}</div>;
};

export default PageContainer;
